/**
 * Modules
 */

/**
 * Expose isNumber
 */

module.exports = isNumber['default'] = isNumber

/**
 * isNumber
 */

function isNumber (value) {
  return typeof value === 'number'
}



//////////////////
// WEBPACK FOOTER
// ../~/@f/is-number/lib/index.js
// module id = 1031
// module chunks = 0